import { render, staticRenderFns } from "./EquipItemFields.vue?vue&type=template&id=4fab575a&scoped=true"
import script from "./EquipItemFields.vue?vue&type=script&lang=js"
export * from "./EquipItemFields.vue?vue&type=script&lang=js"
import style0 from "./EquipItemFields.vue?vue&type=style&index=0&id=4fab575a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fab575a",
  null
  
)

export default component.exports